// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"1cc9ea46","523":"ad0b4a0c","576":"246481b2"}[chunkId] + ".chunk.js";
};